function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { ROLES_LIST, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from "@/components/DialogsComponent.vue";
import ProjectPermissionComponent from "../../components/ProjectPermissionComponent.vue";
import project_service from '@/apps/chatbots/services/projects_services';
import bots_services from '@/apps/chatbots/services/bots_services';
import GridCardComponent from '@/components/work_environments/GridCardComponent';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
export default {
  components: {
    ProjectPermissionComponent: ProjectPermissionComponent,
    GridCardComponent: GridCardComponent,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      DATAPLEX_STATES: DATAPLEX_STATES,
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      item_selected: {},
      data: [],
      data_to_filter: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      permissions: [],
      headers_executions: [{
        value: 'uid',
        text: 'UID'
      }, {
        value: 'state',
        text: 'Estado'
      }, {
        value: 'startTime',
        text: 'Fecha Inicio'
      }, {
        value: 'endTime',
        text: 'Fecha Fin'
      }, {
        value: 'actions',
        text: 'Acciones'
      }],
      chatbots: [],
      connections: [],
      alcances: [{
        text: 'Datos Completos',
        value: 'FULL'
      }, {
        text: 'Incremental',
        value: 'INCREMENTAL'
      }],
      rules: {
        display_name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 256 || 'Menor o igual a 256 caracteres.';
        }],
        description: [function (v) {
          return v == "" || v == undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }],
        data_scan_id: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 63 || 'Menor o igual a 63 caracteres.';
        }, function (v) {
          return /^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/.test(v) || 'Solo minúsculas, empieza con una letra, puede contener letras, numero o guiones, debe terminar con una letra o número.';
        }],
        table_input: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
        }],
        table_output: [function (v) {
          return v == "" || v == undefined || v == null || /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
        }],
        dependent: function dependent(parent) {
          return [function (v) {
            return !parent || !!v || 'El campo es requerido.';
          }];
        }
      },
      default_config: {},
      domain_selected: userInfo.domain,
      list_orgs: [],
      total_projects: 0,
      total_projects_prod: 0,
      env_selected: "dev",
      chatbotTypeText: {
        personal: 'Asistente personal IA',
        conversation: 'Agente Conversacional',
        advisor: 'Asistente de Call Center'
      },
      chatbotEnvText: {
        dev: 'Sandbox',
        prod: 'Versión final'
      },
      dialog_agent_title: null,
      list_env: [{
        value: null,
        text: this.traductor('my_tasks.all')
      }, {
        value: 'dev',
        text: this.traductor('chatbots.projects.create_dev')
      }, {
        value: 'prod',
        text: this.traductor('chatbots.projects.create_prod')
      }],
      item_to_change_to_prod: {},
      item_to_generate_sandbox: {},
      new_owner: "",
      type_embedding_source: [
      //{ value: 'azure', text: 'Azure Embedding'},
      {
        value: 'gemini',
        text: 'Gemini'
      }],
      type_embedding: [
      //{ value: 'text-embedding-3-large', text: 'text-embedding-3-large', source: 'azure'},
      {
        value: 'gemini-embedding-001',
        text: 'gemini-embedding-001',
        source: 'gemini'
      }],
      type_bd_vectorial: [
      //{ value: 'azure', text: 'Azure AI Search'},
      {
        value: 'qdrant',
        text: 'Qdrant'
      }],
      bd_instance: [{
        value: 'qdrant-dev',
        text: "Qdrant DEV",
        source: "qdrant"
      }, {
        value: 'qdrant-prd',
        text: "Qdrant PROD",
        source: "qdrant"
      }, {
        value: 'qdrant-custom',
        text: "Qdrant CUSTOM",
        source: "qdrant"
      }
      //{ value: 'azure-base', text: "AI Search Base", source: "azure"}
      ],
      config_migration: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers: function headers() {
      return [{
        value: 'env',
        text: this.traductor('chatbots.projects.env')
      }, {
        value: 'project_name',
        text: this.traductor('chatbots.projects.name_agent')
      }, {
        value: 'chatbot_type',
        text: this.traductor('chatbots.projects.agent_type')
      }, {
        value: 'chatbot',
        text: this.traductor('chatbots.projects.chatbot')
      },
      //{ value: 'description', text: this.traductor('chatbots.projects.description') },
      {
        value: 'connections',
        text: this.traductor('chatbots.projects.connections')
      }, {
        value: 'created_date_desc',
        text: this.traductor('chatbots.projects.created_date')
      }, {
        value: 'created_user',
        text: this.traductor('chatbots.projects.created_user')
      }, {
        value: 'actions',
        text: this.traductor('chatbots.projects.actions')
      }];
    },
    cards: function cards() {
      return [{
        title_es: 'Asistente IA para asesores de Call Center',
        title_en: 'CallCenter AI Agent',
        color: '#F1F1F1',
        image: 'Request.png',
        flex: 6,
        path: process.env.VUE_APP_PLAYGROUND + '/edit?type=advisor&env=' + this.env_selected,
        access: true,
        external_path: true
      }, {
        title_es: 'Asistente Personal de IA',
        title_en: 'Personal AI Agent',
        color: '#F1F1F1',
        image: 'Request.png',
        flex: 6,
        path: process.env.VUE_APP_PLAYGROUND + '/edit?type=personal&env=' + this.env_selected,
        access: true,
        external_path: true
      }, {
        title_es: 'Agentes conversacionales',
        title_en: 'Chat Agent',
        color: '#F1F1F1',
        image: 'UploadData.png',
        flex: 6,
        path: process.env.VUE_APP_PLAYGROUND + '/edit?type=conversation&env=' + this.env_selected,
        access: true,
        external_path: true
      },
      /*{
      title_es: 'Agentes en canales',
      title_en: 'Channel agents',
      color: '#F1F1F1',
      image: 'Model.png',
      flex: 6,
      path: '/Chatbots/ProjectManagement/Create',
      access: true,
      
      },*/
      {
        title_es: 'Asistente de voz',
        title_en: 'Voice Assistance',
        color: '#F1F1F1',
        image: 'Model.png',
        flex: 6,
        path: '',
        access: false
      }];
    },
    filteredEmbeddings: function filteredEmbeddings() {
      var _this = this;
      if (!this.config_migration.source_embedding) return [];
      return this.type_embedding.filter(function (e) {
        return e.source === _this.config_migration.source_embedding;
      });
    },
    filteredInstances: function filteredInstances() {
      var _this2 = this;
      if (!this.config_migration.database_service) return [];
      return this.bd_instance.filter(function (e) {
        return e.source === _this2.config_migration.database_service;
      });
    },
    filteredData: function filteredData() {
      if (this.userHasRole("support_developer")) {
        return this.data;
      } else {
        return this.data.filter(function (item) {
          if (item.env === 'prod') return true;
          if (item.env === 'dev' && !item.prd_project_id) return true;
          return false;
        });
      }
    }
  }),
  created: function created() {
    this.getDefaultConfig();
    this.listProjects();
    this.listChatbots();
    this.getListOrgsDetailed();
    this.listConnections();
    console.log("adsadsadasd", userInfo);
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    formatDate: function formatDate(data) {
      if (data) return data ? data.substring(0, 19).replace("T", " ") : '';
      return "";
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      var _this3 = this;
      this.data = Object.assign([], this.data_to_filter);
      console.log("filters", this.filters);
      if (this.filters.project_name) {
        this.data = this.data.filter(function (x) {
          return x.project_name.toUpperCase().indexOf(_this3.filters.project_name.toUpperCase()) != -1;
        });
      }
      if (this.filters.env) {
        this.data = this.data.filter(function (x) {
          return x.env && x.env.toUpperCase().includes(_this3.filters.env.toUpperCase());
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.data = Object.assign([], this.data_to_filter);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
      this.listProjects();
    },
    getChatbotName: function getChatbotName(id) {
      var item = this.chatbots.find(function (x) {
        return x.id == id;
      });
      if (item) return item.name;
      return "";
    },
    getConnectionName: function getConnectionName(id) {
      var item = this.connections.find(function (x) {
        return x.id == id;
      });
      if (item) {
        return item.name;
      }
      return "";
    },
    isConnectionPlayground: function isConnectionPlayground(id) {
      var item = this.connections.find(function (x) {
        return x.id == id;
      });
      if (item && item.type == "PLAYGROUND") {
        return item.url;
      }
      return null;
    },
    isAdministrator: function isAdministrator(item) {
      console.log("userInfo.email", userInfo.email);
      if (item.created_user == userInfo.email) return true;
      if (!item || !item.permissions || !Array.isArray(item.permissions)) {
        return false;
      }
      var permission = item.permissions.find(function (p) {
        return p.email === userInfo.email && !p.deleted;
      });
      return permission ? permission.administrator === true : false;
    },
    onOpenPlayground: function onOpenPlayground(idCon, project) {
      var item = this.connections.find(function (x) {
        return x.id == idCon;
      });
      if (item && item.type == "PLAYGROUND") {
        var url = item.url + "?key_p=" + project.id + "&key_u=" + idCon;
        window.open(url, '_blank');
      }
    },
    listChatbots: function listChatbots() {
      var _this4 = this;
      bots_services.getAll().then(function (response) {
        _this4.chatbots = response.data;
      });
    },
    listConnections: function listConnections() {
      var _this5 = this;
      project_service.getConnections().then(function (response) {
        _this5.connections = response.data;
      });
    },
    listProjects: function listProjects() {
      var _this6 = this;
      project_service.getAll(this.domain_selected).then(function (response) {
        console.log(response);
        if (response.success) {
          _this6.data = response.data;
          _this6.total_projects = _this6.data.length;
          _this6.total_projects_prod = _this6.data.filter(function (project) {
            return project.env === "prod";
          }).length;
          _this6.data.forEach(function (e) {
            e.created_date_desc = utils.getToDatetimeString(new Date(e.created_date));
          });
          _this6.data_to_filter = Object.assign([], _this6.data);
          _this6.pagination.total = response.data.length;
        }
      });
    },
    goCreatePage: function goCreatePage(env) {
      console.log("creando en entorno: ", env);
      this.env_selected = env;
      this.dialog_agent_title = this.env_selected == "dev" ? "Crear agente: " + this.traductor('chatbots.projects.create_dev') : "Crear agente: " + this.traductor('chatbots.projects.create_prod');
      this.$refs.dialogProject.onOpen();

      //this.$router.push({name: "ProjectManagementCreate"})
    },
    onEditProject: function onEditProject(item) {
      console.log(item);
      if (item.chatbot_type) {
        var link = this.connections.find(function (x) {
          return x.id == item.connections[0];
        });
        link = link.url;
        var keyP = item.env === 'prod' ? item.dev_project_id : item.id;
        var url = "".concat(link, "/edit?type=").concat(item.chatbot_type, "&key_p=").concat(keyP, "&key_u=").concat(item.connections[0]);
        //let url= link+'/edit?type='+item.chatbot_type+"&key_p=" + item.id + "&key_u=" + item.connections[0]
        window.open(url, '_blank');
      } else {
        this.$router.push({
          name: "ProjectManagementUpdate",
          params: {
            id: item.id
          }
        });
      }
    },
    onViewProject: function onViewProject(item) {
      if (item.chatbot_type) {
        var link = this.connections.find(function (x) {
          return x.id == item.connections[0];
        });
        link = link.url;
        var url = link + '?type=' + item.chatbot_type + "&key_p=" + item.id + "&key_u=" + item.connections[0];
        window.open(url, '_blank');
      } else {
        this.$router.push({
          name: "ProjectManagementView",
          params: {
            id: item.id
          }
        });
      }
    },
    onRemoveProject: function onRemoveProject(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs["DIALOG_REMOVE_PROJECT"].onOpen();
    },
    onChangeToProd: function onChangeToProd(item) {
      this.item_to_change_to_prod = Object.assign({}, item);
      this.$refs["DIALOG_CHANGE_TO_PROD"].onOpen();
    },
    onEditPermission: function onEditPermission(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs["DIALOG_PERMISSIONS_PROJECT"].onOpen();
      this.listPermissions();
    },
    listPermissions: function listPermissions() {
      var _this7 = this;
      project_service.getPermissions(this.item_selected.id).then(function (response) {
        _this7.permissions = [];
        response.data.forEach(function (item) {
          var obj = Object.assign({}, item);
          obj.email = "" + obj.email;
          delete obj.id;
          _this7.permissions.push(obj);
        });
      });
    },
    upsertPermissions: function upsertPermissions() {
      var _this8 = this;
      var data = {
        data: this.permissions,
        domain: this.item_selected.domain
      };
      project_service.upsertPermissions(this.item_selected.id, data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Permiso agregado correctamente.");
          _this8.listPermissions();
        } else {
          tasks.toast.error("No se pudo agregar el permiso.");
        }
      });
    },
    addPermissions: function addPermissions(permission) {
      var _this9 = this;
      if (!this.$refs.form_permission.validate()) return;
      var data = {
        id: permission.email,
        edit_permission: permission.edit_permission,
        delete_permission: permission.delete_permission
      };
      project_service.addPermissions(this.item_selected.id, data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Permiso agregado correctamente.");
          _this9.listPermissions();
        } else {
          tasks.toast.error("No se pudo agregar el permiso.");
        }
      });
    },
    updatePermissions: function updatePermissions(permission) {
      var _this0 = this;
      var data = {
        id: permission.email,
        edit_permission: permission.edit_permission,
        delete_permission: permission.delete_permission
      };
      project_service.updatePermissions(this.item_selected.id, data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Permiso modificado correctamente.");
          _this0.listPermissions();
        } else {
          tasks.toast.error("No se pudo guardar el permiso.");
        }
      });
    },
    deletePermissions: function deletePermissions(permission) {
      var _this1 = this;
      var data = {
        id: permission.email
      };
      project_service.deletePermissions(this.item_selected.id, data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Permiso eliminado correctamente.");
          _this1.listPermissions();
        } else {
          tasks.toast.error("No se pudo eliminar el permiso.");
        }
      });
    },
    onConfirmRemoveProject: function onConfirmRemoveProject(value) {
      var _this10 = this;
      if (value) {
        project_service.delete(this.item_selected.id).then(function (response) {
          if (response.success) {
            tasks.toast.success("Se ha eliminado correctamente el registro.");
            _this10.$refs["DIALOG_REMOVE_PROJECT"].onClose();
            _this10.onLimpiar();
          }
        });
      } else {
        this.$refs["DIALOG_REMOVE_PROJECT"].onClose();
      }
    },
    getHref: function getHref(item, con) {
      if (item.chatbot_type) {
        var link = this.connections.find(function (x) {
          return x.id == item.connections[0];
        });
        link = link.url;
        var url = link + '?type=' + item.chatbot_type + "&key_p=" + item.id + "&key_u=" + item.connections[0];
        return url;
      } else {
        return this.isConnectionPlayground(con) + '?key_p=' + item.id + '&key_u=' + con;
      }
    },
    getProjectLink: function getProjectLink(item) {
      if (item.chatbot_type) {
        var link = this.connections.find(function (x) {
          return x.id === item.connections[0];
        });
        if (link) {
          return "".concat(link.url, "?type=").concat(item.chatbot_type, "&key_p=").concat(item.id, "&key_u=").concat(item.connections[0]);
        }
      }
      return this.$router.resolve({
        name: "ProjectManagementView",
        params: {
          id: item.id
        }
      }).href;
    },
    getDefaultConfig: function getDefaultConfig() {
      var _this11 = this;
      project_service.getDefaultConfig().then(function (response) {
        _this11.default_config = response.data;
      });
    },
    getListOrgsDetailed: function getListOrgsDetailed() {
      var _this12 = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success) {
          if (userInfo.domain == "intercorp.com.pe") {
            _this12.list_orgs = response.data;
          } else {
            var orgs = _this12.default_config.orgs ? _this12.default_config.orgs : [];
            if (!orgs.includes(userInfo.domain)) {
              orgs.push(userInfo.domain);
            }
            _this12.list_orgs = response.data.filter(function (item) {
              return orgs.includes(item.domain);
            });
          }
        }
      });
    },
    onConfirmChangeToProd: function onConfirmChangeToProd(value) {
      var _this13 = this;
      if (value) {
        console.log("change", this.item_to_change_to_prod);
        project_service.changeToProd(this.item_to_change_to_prod).then(function (response) {
          if (response.success) {
            tasks.toast.success("Cambio a versión final exitoso.");
            _this13.listProjects();
            _this13.$refs["DIALOG_CHANGE_TO_PROD"].onClose();
          } else {
            tasks.toast.error("No se pudo cambiar a versión final.");
            _this13.$refs["DIALOG_CHANGE_TO_PROD"].onClose();
          }
        });
      } else {
        this.$refs["DIALOG_CHANGE_TO_PROD"].onClose();
      }
    },
    onChangeOwner: function onChangeOwner(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs['owner_dialog'].onOpen();
    },
    changeOwner: function changeOwner() {
      var _this14 = this;
      var data = {
        item: this.item_selected,
        new_owner: this.new_owner
      };
      project_service.changeOwner(data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Propietario cambiado correctamente.");
          _this14.$refs['owner_dialog'].onClose();
          _this14.listProjects();
        } else {
          tasks.toast.error("No se pudo cambiar el propietario.");
        }
      });
    },
    onMigrateProject: function onMigrateProject(item) {
      this.item_selected = Object.assign({}, item);
      this.config_migration = {
        database_service: null,
        database_instance: null,
        source_embedding: null,
        tipo_embedding: null
      };
      this.$refs['migrate_project_dialog'].onOpen();
    },
    onChangeBot: function onChangeBot(item) {
      this.item_selected = Object.assign({}, item);
      this.config_migration = {
        chatbot: this.item_selected.chatbot
      };
      this.$refs['change_bot_dialog'].onOpen();
    },
    migrateProject: function migrateProject() {
      var _this15 = this;
      if (!this.$refs.form_migration.validate()) return;
      this.config_migration.chatbot = this.item_selected.chatbot;
      var data = {
        item: this.item_selected,
        config_migration: this.config_migration
      };
      project_service.migrateProject(data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Proyecto migrado correctamente.");
          _this15.$refs['migrate_project_dialog'].onClose();
          _this15.listProjects();
        } else {
          tasks.toast.error("No se pudo cambiar el propietario.");
        }
      });
    },
    changeBot: function changeBot() {
      var _this16 = this;
      if (!this.$refs.form_change_bot.validate()) return;
      this.config_migration.chatbot = this.item_selected.chatbot;
      var data = {
        item: this.item_selected,
        config_migration: this.config_migration
      };
      project_service.changeBot(data).then(function (response) {
        if (response.success) {
          tasks.toast.success("Chatbot cambiado correctamente.");
          _this16.$refs['change_bot_dialog'].onClose();
          _this16.listProjects();
        } else {
          tasks.toast.error("No se pudo cambiar el chatbot.");
        }
      });
    },
    onGenerateSandbox: function onGenerateSandbox(item) {
      this.item_to_generate_sandbox = Object.assign({}, item);
      this.$refs["DIALOG_GENERATE_SANDBOX"].onOpen();
    },
    onConfirmGenerateSandbox: function onConfirmGenerateSandbox(value) {
      var _this17 = this;
      if (value) {
        console.log("sandbox", this.item_to_generate_sandbox);
        project_service.generateSandbox(this.item_to_generate_sandbox).then(function (response) {
          if (response.success) {
            tasks.toast.success("Sandbox generado exitosamente.");
            _this17.listProjects();
            _this17.$refs["DIALOG_GENERATE_SANDBOX"].onClose();
          } else {
            tasks.toast.error("No se pudo generar el sandbox.");
            _this17.$refs["DIALOG_GENERATE_SANDBOX"].onClose();
          }
        });
      } else {
        this.$refs["DIALOG_GENERATE_SANDBOX"].onClose();
      }
    }
  }
};